module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.2.0.0.box.340.899.880.42.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "108%",
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.2.0.0.box.340.899.880.42.q.80"
    }
  }, [_vm._v("THE GOVERNORS OF TEXAS")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.2.1.0.box.988.2346.546.208.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.3.0.0.box.641.989.584.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.0.0.box.641.989.584.33.q.80"
    }
  }, [_vm._v("BOOKS BY ROSS PHARES")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.3.1.0.box.649.1097.568.195.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    },
    attrs: {
      "id": "para.3.1.0.box.649.1097.568.38.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.1.0"
    }
  }), _vm._v("Bible in Pocket, Gun in Hand")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.1.1.box.778.1151.305.33.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.2.0"
    }
  }), _vm._v("Texas Tradition")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.1.2.box.686.1206.493.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.3.0"
    }
  }), _vm._v("Cavalier in the Wilderness")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.1.3.box.788.1260.291.32.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.4.0"
    }
  }), _vm._v("Reverend Devil")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.3.2.0.box.549.1419.770.32.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.2.0.box.549.1419.770.32.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.1.0.0"
    }
  }), _vm._v("THE PELICAN GOVERNORS SERIES")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.3.3.0.box.435.1527.996.369.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.3.0.box.481.1527.909.43.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.1.1.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Governors ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Louisiana, ")]), _vm._v("by Miriam Reeves")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    },
    attrs: {
      "id": "para.3.3.1.box.443.1581.982.43.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.1.2.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Governors ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Alabama, ")]), _vm._v("by John Craig Stewart")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.3.2.box.544.1635.779.44.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.1.3.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Governors ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Texas, ")]), _vm._v("by Ross Phares")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.3.3.box.796.1691.276.43.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.1.4.0"
    }
  }), _vm._v("In Preparation")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.3.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    },
    attrs: {
      "id": "para.3.3.4.box.456.1745.959.44.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.1.5.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Governors ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tennessee, ")]), _vm._v("by Margaret Phillips")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.3.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    },
    attrs: {
      "id": "para.3.3.5.box.435.1799.996.45.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.1.6.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Governors ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Florida, ")]), _vm._v("by Martin La Godna and")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP4.w.3.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.3.6.box.795.1855.268.41.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP4.w.1.7.0"
    }
  }), _vm._v("John TePaske")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.0.0.box.298.752.1008.576.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "151%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.4.0.0.box.298.752.1008.576.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.3.0"
    }
  }), _vm._v("THE GOVERNORS OF TEXAS")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.1.0.box.460.1547.665.204.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP5.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "116%",
      "text-indent": "0",
      "text-align": "center"
    },
    attrs: {
      "id": "para.4.1.0.box.749.1547.80.73.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.4.0"
    }
  }), _vm._v("By ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "142%",
      "text-align": "center",
      "font-weight": "bold",
      "text-indent": "0"
    },
    attrs: {
      "id": "para.4.1.1.box.460.1659.665.92.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.5.0"
    }
  }), _vm._v("Ross Phares")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.2.0.box.516.2094.530.31.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP5.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.4.2.0.box.516.2094.530.31.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.1.0.0"
    }
  }), _vm._v("A FIREBIRD PRESS BOOK")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.3.0.box.542.2285.480.56.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP5.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.4.3.0.box.542.2285.480.22.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.2.0.0"
    }
  }), _vm._v("PEUCAN PUBLISHING COMPANY")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP5.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center"
    },
    attrs: {
      "id": "para.4.3.1.box.703.2318.157.23.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP5.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.0.0"
    }
  }), _vm._v("Gretna 1998")]), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.1.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.3.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.4.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.5.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.6.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.7.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0.2"
    }
  }), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP6"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 5",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0.4"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PP7"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96e7b036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0004.vue
// module id = 54
// module chunks = 0